/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'fill-gauge': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _fill="#fff" transform="translate(6.237 5.966) scale(.77401)"><g transform="translate(.613 .464)"><g><path pid="0" d="M12 4C5.383 4 0 9.383 0 16v4.5a.5.5 0 00.5.5h23a.5.5 0 00.5-.5V16c0-6.617-5.383-12-12-12zm2.408 4.879l.766-1.848a.5.5 0 11.924.382l-.766 1.848a.497.497 0 01-.653.269.497.497 0 01-.271-.651zM11.5 6.5a.5.5 0 011 0v2a.5.5 0 01-1 0zM4.5 17h-2a.5.5 0 010-1h2a.5.5 0 010 1zm1.032-3.678a.5.5 0 01-.653.271l-1.847-.765a.5.5 0 01.382-.925l1.847.766a.497.497 0 01.271.653zm1.517-2.272a.5.5 0 01-.707 0L4.93 9.635a.5.5 0 010-.707h.001a.5.5 0 01.707.002l1.411 1.414a.5.5 0 010 .706zm2.272-1.517a.498.498 0 01-.653-.271l-.765-1.848a.5.5 0 11.924-.383l.765 1.849a.5.5 0 01-.271.653zm4.094 7.881a2 2 0 01-2.828-2.828 1.996 1.996 0 012.425-.303l4.636-4.636a.5.5 0 01.707.707l-4.636 4.636c.45.766.353 1.766-.304 2.424zm5.051-4.093a.5.5 0 01.272-.653l1.848-.765a.5.5 0 01.382.923l-1.848.765a.5.5 0 01-.654-.27zM21.5 17h-2a.5.5 0 010-1h2a.5.5 0 010 1z"/></g></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/fill-gauge.js